import React from "react";
import { useTranslation } from "react-i18next";
import AppWidgetCard from "components/ui/AppWidgetCard";

const PaymentLinkStats = ({ earning }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-3  gap-1 md:gap-6 mt-4 my-3">
        <AppWidgetCard title={t("Cash Orders Links")} amount={earning} isPrice={true}></AppWidgetCard>
    </div>
  );
};

export default PaymentLinkStats;
